import { useQuery } from "@tanstack/react-query";
import { statisticsRepository } from "@/config/dataSource";

export function usePodiums(leagueId: string | undefined) {
  return useQuery({
    queryKey: ["podiums", leagueId ?? "unknown"],
    queryFn: () => statisticsRepository.getPodiums(leagueId as string),
    enabled: Boolean(leagueId),
  });
}

/** Última rodada com pontuação real registrada — usada como padrão da aba
 * "Rodada" do Ranking (nunca a "próxima a acontecer", que sempre mostraria
 * 0 mesmo com a rodada anterior já pontuada). */
export function useLatestScoredRound(leagueId: string | undefined) {
  return useQuery({
    queryKey: ["latest-scored-round", leagueId ?? "unknown"],
    queryFn: () => statisticsRepository.getLatestScoredRound(leagueId as string),
    enabled: Boolean(leagueId),
  });
}
